import { render, staticRenderFns } from "./resetPass.vue?vue&type=template&id=2cad1c33&scoped=true&"
import script from "./resetPass.vue?vue&type=script&lang=js&"
export * from "./resetPass.vue?vue&type=script&lang=js&"
import style0 from "./resetPass.vue?vue&type=style&index=0&id=2cad1c33&prod&lang=scss&"
import style1 from "./resetPass.vue?vue&type=style&index=1&id=2cad1c33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad1c33",
  null
  
)

export default component.exports